import React from "react";
import PropTypes from "prop-types";

import ReconciliationRow from "./ReconciliationRow";
import { reconciliationItemShape } from "../../../constants/reconciliationItemShape";

const ReconciliationTotalRow = ({
  displayName,
  reconciliationDataFieldName,
  reconciliationData,
  classes,
  isNegative,
}) => (
  <ReconciliationRow
    displayName={displayName}
    reconciliationDataFieldName={reconciliationDataFieldName}
    reconciliationData={reconciliationData}
    classes={classes}
    insertDivider
    bold
    underlined={false}
    isNegative={isNegative}
    hasLeftMargin
    hasVerticalSpacing
  />
);

ReconciliationTotalRow.propTypes = {
  displayName: PropTypes.string.isRequired,
  reconciliationDataFieldName: PropTypes.string.isRequired,
  reconciliationData: PropTypes.shape({
    audited: reconciliationItemShape,
    current: reconciliationItemShape,
    changes: reconciliationItemShape,
    variance: reconciliationItemShape,
    meta: PropTypes.shape({
      isAudited: PropTypes.bool,
    }),
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- See financialTableStyles
  classes: PropTypes.object.isRequired,
  isNegative: PropTypes.bool,
};

ReconciliationTotalRow.defaultProps = {
  isNegative: false,
};

export default ReconciliationTotalRow;
